import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
import useAuthStore from "../store/auth";

export default function LoginPage() {
  const { t } = useTranslation();
  const { login } = useAuthStore();
  const navigate = useNavigate();
  const [form, setForm]   = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(form.email, form.password);
      if (user?.email_verified === false) { navigate("/verify-email-pending"); return; }
      const pending = localStorage.getItem("bf_pending_invite");
      if (pending) {
        try {
          const { familyAPI } = await import("../api");
          await familyAPI.acceptInvite(pending);
          localStorage.removeItem("bf_pending_invite");
          toast.success("Vous avez rejoint le groupe familial !");
          navigate("/family"); return;
        } catch {}
      }
      navigate("/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.error || t("error"));
    } finally { setLoading(false); }
  };

  return (
    <div className="auth-page" style={{ background: "radial-gradient(ellipse 80% 60% at 50% -10%,#2d1f7a44,transparent),var(--bg)" }}>
      <div className="auth-box" style={{ boxShadow: "0 40px 80px #00000060" }}>
        <div style={{ fontFamily: "Syne,sans-serif", fontSize: 28, fontWeight: 800, background: "linear-gradient(135deg,#7c6af7,#f7c26a)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", marginBottom: 4 }}>BudgetFlow</div>
        <h2 style={{ fontFamily: "Syne,sans-serif", fontSize: 20, fontWeight: 700, marginBottom: 4 }}>{t("login_title")}</h2>
        <p style={{ color: "var(--text2)", fontSize: 13, marginBottom: 28 }}>{t("login_sub")}</p>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: "block", fontSize: 13, color: "var(--text2)", marginBottom: 8 }}>{t("email")}</label>
            <input type="email" required value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} style={{ padding: "12px 16px" }} placeholder="jean@email.com" />
          </div>
          <div style={{ marginBottom: 8 }}>
            <label style={{ display: "block", fontSize: 13, color: "var(--text2)", marginBottom: 8 }}>{t("password")}</label>
            <input type="password" required value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} style={{ padding: "12px 16px" }} placeholder="••••••••" />
          </div>
          <div style={{ textAlign: "right", marginBottom: 24 }}>
            <Link to="/forgot-password" style={{ fontSize: 13, color: "var(--accent)" }}>{t("forgot_password")}</Link>
          </div>
          <button type="submit" disabled={loading} className="btn btn-primary" style={{ width: "100%", padding: 14, fontSize: 15, opacity: loading ? 0.7 : 1 }}>
            {loading ? t("loading") : t("login")}
          </button>
        </form>
        <p style={{ textAlign: "center", marginTop: 20, fontSize: 13, color: "var(--text3)" }}>
          {t("no_account")} <Link to="/register" style={{ color: "var(--accent)" }}>{t("register")}</Link>
        </p>
      </div>
    </div>
  );
}